import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SidepanelLayoutComponent } from '@engie-group/fluid-design-system-angular';
import { Assets } from 'src/app/core/Dtos/assets-enum';
import { TraderInstructionArgs } from './trader-instruction-view-args';

@Component({
  selector: 'app-dashboards-viewer',
  templateUrl: './dashboards-viewer.component.html',
  styleUrl: './dashboards-viewer.component.scss',
  standalone: false
})
export class DashboardsViewerComponent {
  @ViewChild('layout') layout!: SidepanelLayoutComponent;
  @ViewChild('contentToPrint') contentToPrint!: ElementRef;

  public ShowTradersDashboard: boolean = false;
  public ShowMOWEODashboard: boolean = false;
  public ShowMOWWLDashboard: boolean = false;
  public ShowFHCDashboard: boolean = false;
  public ShowRetailDashboard: boolean = false;
  public ShowResDashboard: boolean = false;

  public AssetToView: string = "";
  public InstructionIdToView: string|number = 0;
  public ActiveInstructionStatus: string = "";
  public Title: string = ""

  constructor(private _activatedRoute: ActivatedRoute)
  {
    switch (_activatedRoute.snapshot.routeConfig?.path) {
      case "moweo":
        this.ShowMOWEODashboard = true; break;
      case "mowwl":
        this.ShowMOWWLDashboard = true; break;
      case "fhc":
        this.ShowFHCDashboard = true; break;
      case "retail":
        this.ShowRetailDashboard = true; break;
      case "res":
        this.ShowResDashboard = true; break;
      default:
        this.ShowTradersDashboard = true; break;
    
    }
  }
  ngAfterViewInit() {
    this.layout?.hidePanel();
  }

  public sidepanelVisibilityChange(value: any){
  }

  public ViewInstruction(asset: string, instructionId: string | number): void {
    this.Title = "Instruction for " + asset + ". #" + instructionId.toString();
    this.InstructionIdToView = instructionId;
    this.AssetToView = asset;
    this.layout?.showPanel();
  }
  
  public ViewTraderInstruction(instructionInfo: any): void {
    let instructionData = instructionInfo as TraderInstructionArgs;
    if (instructionData.IsAdHoc == true)
      this.AssetToView = "AdHoc"
    else
      this.AssetToView = instructionData.Asset == Assets.FirstHydro ? "fhc" :
        instructionData.Asset == Assets.MorayEast ? "moweo" :
        instructionData.Asset == Assets.MorayWest ? "mowwl" : 
        instructionData.Asset == Assets.Res ? "res" : "retail";
    this.Title = "Instruction for " + instructionData.Asset + ". #" + instructionData.InstructionId.toString();
    this.InstructionIdToView = instructionData.InstructionId;
    this.layout?.showPanel();
    //this.AssetToView = asset;
  }

  
  public PrintContent(): void {
    const printWindow = window.open('', '_blank', 'width=600,height=600');
    const appStyles = document.querySelectorAll('style, link[rel="stylesheet"]');
    let stylesContent = '';
    
    // Copy styles to the print window
    appStyles.forEach((styleElement: any) => {
      if (styleElement.tagName.toLowerCase() === 'style') {
        stylesContent += `<style>${styleElement.innerHTML}</style>`;
      } else if (styleElement.tagName.toLowerCase() === 'link') {
        const href = styleElement.getAttribute('href');
        stylesContent += `<link rel="stylesheet" href="${href}">`;
      }
    });

    printWindow?.document.write(`
      <html>
        <head>
          <title>Print</title>
          ${stylesContent}
        </head>
        <body>
          <div class="content">
            ${this.contentToPrint.nativeElement.innerHTML}
          </div>
        </body>
      </html>
    `);
    printWindow?.document.close();
    
    setTimeout(() => {printWindow?.print()}, 1000);
  }
}